// extracted by mini-css-extract-plugin
export default {"wrapper":"fENqg1","titles":"MOkNml","title":"OuOsIJ","subtitle":"MI3hay","options":"r9FmB4"};